import { Button } from '@lendi-ui/button';
import { Check } from '@lendi-ui/fancy-icon';
import Modal from '@lendi-ui/modal';
import { Body } from '@lendi-ui/typography';

import { FunnelGrid, FunnelGridUnit } from '@funnels/ui-components';

type NavigationBlockerModalProps = {
  isVisible: boolean;
  onHide: () => void;
  onContinueToRefer: () => void;
  onCompleteLater: () => void;
};

export const ConveyancingBlockerModal = ({
  isVisible,
  onHide,
  onContinueToRefer,
  onCompleteLater,
}: NavigationBlockerModalProps) => {
  return (
    <Modal role="dialog" isVisible={isVisible} size="lg" onHide={onHide} isHeaderFixed={true}>
      <Modal.Content>
        <Body align="center" mt={'xl'}>
          <Check width="60px" height="60px" />
          <Body mt={'md'} size={'md'}>
            Your intent to use our conveyancing services has been noted.
            <br />
            To complete the referral, please fill out the necessary form,
            <br />
            which you can find under Other Products on the Application
            <br />
            management page.
          </Body>
        </Body>
      </Modal.Content>
      <Modal.Footer>
        <FunnelGrid direction="row">
          <FunnelGridUnit size={1 / 2}>
            <Button variant="secondary" onClick={onContinueToRefer} isFullWidth>
              Continue to referral
            </Button>
          </FunnelGridUnit>
          <FunnelGridUnit size={1 / 2}>
            <Button variant="primary" onClick={onCompleteLater} isFullWidth>
              Complete later
            </Button>
          </FunnelGridUnit>
        </FunnelGrid>
      </Modal.Footer>
    </Modal>
  );
};
